// eslint-disable-next-line import/prefer-default-export
export enum CookiesListNames {
  candidatesShoppingList = 'candidatesShoppingList'
}
